import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './component/Home';
import InfoPage from './component/Info/InfoPage';
import Cart from './component/Cart/Cart';
import Checkout from './component/checkout/Checkout';

//routing logic
function App() {

    return (
        <>
            <Router>
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route exact path="/cart" element={<Cart />} />
                    <Route exact path="/checkout" element={<Checkout />} />
                    <Route exact path="/product/:id" element={<InfoPage />} />
                </Routes>
            </Router>
        </>
    )
}

export default App;